export default {
      id: "txt_h2-usage",
      viewBox: "0 0 21 16",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#txt_h2",
      toString: function () {
        return this.url;
      }
    }